/**
 * @file: useChatRefusal.ts
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

import { ChatRefusal } from '@euler/app/flows/chat/lib/session/client';
import { useChatSession } from '@euler/app/flows/chat/lib/session/context';
import { useBehaviorSubject } from '@euler/utils/hooks';

/** Why the gateway refused this store's chat for good, if it did. */
export function useChatRefusal(): ChatRefusal | null {
  const { wsClient } = useChatSession();
  const [refusal] = useBehaviorSubject(wsClient.refusal$);
  return refusal;
}
